import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import SplitterProps from './SplitterProps'
import KendoSplitterPane from './KendoSplitterPane'

export default {
    props: SplitterProps,
    render (h) {
        return h('div',this.$slots.default)
    },
    mixins: [
        KendoBaseComponent
    ],
    mounted() {
        this._resolveChildren()

        kendo.jQuery(this.$el).kendoSplitter(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoSplitter()
        },
        _resolveChildren() {
            this.resolveChildren('panes', KendoSplitterPane.name)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoSplitter/KendoSplitterMixin.js